import * as React from 'react';
import RatingCountUnit from 'components/RatingCountUnit/RatingCountUnit';
import RatingStarsUnit from 'components/RatingStarsUnit/RatingStarsUnit';
const ProductRatingDetail = (props) => {
    const { rating } = props;
    if (!rating)
        return null;
    // TODO: Potential reduction of DOM nodes here if we can flatten the tree of
    // `row` and `cols`.
    return (<div className="row">
			<div className="col-5-12">
				<RatingCountUnit ratingsCount={rating.count} reviewsCount={rating.reviewCount} avgRating={rating.average}/>
			</div>
			<div className="col-7-12">
				<RatingStarsUnit total={rating.count} breakup={rating.breakup}/>
			</div>
		</div>);
};
export default ProductRatingDetail;
